import axios from 'axios'
import API from '@s/API'

const state = {
    roles: [],

}

const getters = {
    roles: state => {
        return state.roles;
    },



}

const mutations = {
    roles(state,payload){
        state.roles = payload
    },

}

const actions = {
    fetchRoles (context,payload) {
        return axios.get(API.route(API.endpoints.roles.index,{universe: payload}))
            .then(response => {
                context.commit('roles',response.data)
            })
    }
}

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

export default module;


// WEBPACK FOOTER //
// ./src/stores/modules/roles/store.js